import type { PropsWithChildren } from 'react';
import type React from 'react';
import { useMemo } from 'react';

import type { EmptyProps } from '@change-corgi/core/types';
import { I18nOverrides } from '@change-corgi/core-react/i18n';

import { usePsfSharePageData } from './pageData';

/**
 * Serves the sheet copy carried by the revenue_share_promote_slide_up_experiment FC (already
 * locale-resolved by the middle-end, exposed through the experiment's associated config) as
 * corgi.psf.share.promote_slide_up.* through I18nOverrides, per docs/packages/experiments/i18n-copy.md.
 * The FC keeps the copy flat so the Admin UI shows four fields; the key path is the front-end's
 * concern and is where the strings move on productization.
 */
export const PromoteSlideUpCopyI18nOverrides: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const {
		data: {
			experiments: {
				revenueSharePromoteSlideUpExperiment: {
					config: { copy },
				},
			},
		},
	} = usePsfSharePageData();
	const translations = useMemo(() => ({ corgi: { psf: { share: { promote_slide_up: copy } } } }), [copy]);

	return <I18nOverrides translations={translations}>{children}</I18nOverrides>;
};
